//replaces BarChartDemographics.html
import type { FC } from "react";

import { NgToReactChart } from "app/components/React/NgToReactChart/NgToReactChart";
import { WidgetState } from "app/components/widget/widget-types/Widget";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

export const BarChartDemographicsTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    return widget.widgetState === WidgetState.LOADED ? (
        <div className={`chartContainer ${widget.viewOptions.cssClass}`}>
            <NgToReactChart highchartsNgConfig={widget.chartConfig} />
        </div>
    ) : null;
};
